import { createContext, useContext } from "react";

import type { Me } from "@app/api-client";

export interface AuthContextValue {
  /** null = 未登入，或還在載入中 */
  me: Me | null;
  isLoading: boolean;
  login: (account: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
}

/**
 * context 與 hook 刻意與 AuthProvider 分檔。
 *
 * Vite 的 fast refresh 只在「一個檔案只匯出元件」時才有效，把 hook 與常數
 * 混在元件檔裡會讓每次改動都整頁重載（eslint 的 react-refresh 規則會提醒）。
 */
export const AuthContext = createContext<AuthContextValue | null>(null);

export const ME_QUERY_KEY = ["me"] as const;

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth 必須在 AuthProvider 之內使用。");
  return context;
}
